import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ServiceSubCategoryContentsActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ServiceSubCategoryContents/ServiceSubCategoryContentsBrowser")
	}

	render() {
		return (
			<Activity 
				name="ServiceSubCategoryContents"
				RenderedComponent={this.RenderedComponent}
				context="ServiceSubCategoryContents"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ServiceSubCategoryContentsActivity)
